import { useEffect, useState } from "react"
import useHospitalData from "hooks/useHospitalData"

const defaultDepartmentOptions = {
  name: "------",
  id: "",
}

export const useDepartmentsForForm = (setDepartment, setServerState, hospitalId, departmentId, answeredCall) => {
  const [departmentInitialized, setDepartmentInitialized] = useState(false)
  const [departmentOptions, setDepartmentOptions] = useState([])
  const { getDepartments } = useHospitalData(hospitalId)

  useEffect(() => {
    if (getDepartments()) {
      const departments = getDepartments()
      setDepartmentOptions(
        [defaultDepartmentOptions, ...departments].map((dep) => ({
          text: dep.name,
          value: dep.id,
        }))
      )
    }
  }, [getDepartments, setDepartment, setServerState])

  useEffect(() => {
    if (!hospitalId) {
      setDepartmentOptions([defaultDepartmentOptions])
    }
  }, [hospitalId, setDepartment])

  useEffect(() => {
    if (departmentId && departmentOptions.length && !departmentInitialized) {
      setDepartment((v) => v || departmentId)
      setServerState((state) => ({
        ...state,
        departmentId: state.departmentId || departmentId,
      }))
      setDepartmentInitialized(true)
    }
  }, [departmentId, departmentOptions, setDepartment, setServerState, departmentInitialized])

  useEffect(() => {
    if (!answeredCall) {
      setDepartmentOptions([defaultDepartmentOptions])
      setDepartment("")
      setDepartmentInitialized(false)
    }
  }, [answeredCall, setDepartment])

  return {
    departmentOptions,
  }
}
